import { useMutation, useQueryClient } from "@tanstack/react-query";
import { PropertyFieldApiPayload } from "../components/property-details/default/utils/property-fields-transformer";
import { api } from "utils/api";
import { useContext } from "react";
import { AlertsContext } from "providers/alerts";

export const useUpdatePropertyFields = () => {
  const queryClient = useQueryClient();
  const { showSuccess, showError } = useContext(AlertsContext);

  return useMutation({
    mutationFn: async (data: PropertyFieldApiPayload[]) => {
      const propertyId = data[0].property;
      await api.put(`/properties/${propertyId}/fields`, data);
    },
    onSuccess: (_, variables) => {
      showSuccess("Property fields updated successfully");

      // Invalidate and refetch the property fields query
      queryClient.invalidateQueries({
        queryKey: ["property-fields", variables[0].property],
      });
    },
    onError: () => {
      showError("Failed to update property fields");
    },
  });
};
